var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography,
    borders = _ref.borders;
  return {
    contentBackgroundColor: colors.contrasts.white1010,
    contentPaddingTopBottom: 0,
    contentPaddingLeftRight: 0,
    breadCrumbMarginBottom: spacing.large,
    entryRowMargin: spacing.small,
    headerRowColor: colors.contrasts.grey4570,
    headerRowPadding: spacing.small,
    headerTextFontSize: typography.fontSizeSmall,
    leftHeaderMargin: spacing.small,
    headerBackgroundColor: colors.contrasts.grey1111,
    headerColor: colors.contrasts.grey125125,
    headerPaddingTopBottom: spacing.xSmall,
    headerPaddingLeftRight: spacing.small,
    footerPaddingBottom: spacing.xSmall,
    footerPaddingTop: spacing.small,
    rightHeaderPaddingLeft: spacing.xSmall,
    rightFooterPaddingLeftRight: spacing.small,
    entryEditBorderWidth: borders.widthSmall,
    entryEditBorderColor: colors.contrasts.grey1214
  };
};
export default generateComponentTheme;